import {create} from "zustand";
import {useEffect} from "react";
import {readEntries, addEntry, removeEntry} from "../util/recentlyViewed";

export const useRecentlyViewedStore = create((set) => ({
    entries: [],
    hydrated: false,

    hydrate: () => set({ entries: readEntries(), hydrated: true }),
    add: (product) => set({ entries: addEntry(product), hydrated: true }),
    remove: (id) => set({ entries: removeEntry(id), hydrated: true }),
}));

/**
 * 클라이언트에서 마운트된 뒤 저장된 기록을 한 번 불러온다 (SSR에서는 동작하지 않음).
 */
export function useHydrateRecentlyViewed() {
    const hydrated = useRecentlyViewedStore((state) => state.hydrated);
    const hydrate = useRecentlyViewedStore((state) => state.hydrate);

    useEffect(() => {
        if (!hydrated) {
            hydrate();
        }
    }, [hydrated, hydrate]);

    return hydrated;
}
